import { TemplateTask } from "../models/basic/template";
import { AbstractService } from "./abstract-service";
import { URLS } from "./app-urls";
import Api from "./api-config";
import { trackPromise } from "react-promise-tracker";

export class NpiTemplateTaskService extends AbstractService<TemplateTask> {
    constructor() {
        super(URLS.TEMPLATE_TASK);
    }

    async reorder(itemId: number, itemMoveId: number) {
        return await trackPromise(Api.patch(`${this.path}${itemId}/reorder/`, {
            item_move: `${this.path}${itemMoveId}/`,
        }));
    }

    async moveToGroup(taskId: number, newGroupId: number) {
        return await trackPromise(Api.patch(`${this.path}${taskId}/move-to-group/`, {
            group: newGroupId,
        }));
    }
}